@use '@design/design-tokens/border-radius/border-radius' as *;

.alfredFooterRoot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 20px;
}

.hidden {
  visibility: hidden;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--z-index-chat-input);
  background: transparent;
}

.sticky {
  position: sticky;
  bottom: 0;
  inset-inline: 0;
  z-index: 1;
}

.inputRegion {
  --chat-message-width: 1000px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 2;
  width: 100%;
  max-width: var(--chat-message-width);
  min-width: 300px;
}

.collapsible {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 122px;
  min-height: 56px;
  overflow: hidden;
  border-radius: 100px;
  transition:
    width 320ms cubic-bezier(0.16, 1, 0.3, 1),
    border-radius 320ms cubic-bezier(0.16, 1, 0.3, 1);

  &.isJapanese {
    width: 176px;
  }

  &.expanded,
  &:has([data-thinking-feedback-visible]) {
    width: 100%;
    @include border-radius-r2;
  }

  &.settled,
  &:has([data-thinking-feedback-visible]) {
    overflow: visible;

    .panelInner {
      overflow: visible;
    }
  }
}

.trigger {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid transparent;
  border-radius: 100px;
  padding: 0 24px 0 16px;

  background:
    linear-gradient(var(--surface-active), var(--surface-active)) padding-box,
    linear-gradient(120deg, #3e63dd, #9eb1ff, #ffc53d, #ff92ad, #e93d82)
      border-box;
  opacity: 1;
  visibility: visible;
  transition:
    opacity 200ms ease,
    visibility 0s;

  svg {
    fill: var(--icon-default);
  }

  &:hover {
    color: var(--text-primary);

    svg {
      fill: var(--icon-primary);
    }
  }

  .collapsible.expanded &,
  .collapsible:has([data-thinking-feedback-visible]) & {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition:
      opacity 200ms ease,
      visibility 0s 200ms;
  }
}

.panel {
  display: grid;
  grid-template-rows: 0fr;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  transition:
    grid-template-rows 320ms cubic-bezier(0.16, 1, 0.3, 1),
    opacity 200ms ease,
    visibility 0s 320ms;

  .collapsible.expanded &,
  .collapsible:has([data-thinking-feedback-visible]) & {
    grid-template-rows: 1fr;
    opacity: 1;
    visibility: visible;
    transition:
      grid-template-rows 320ms cubic-bezier(0.16, 1, 0.3, 1),
      opacity 220ms ease 80ms,
      visibility 0s;
  }
}

.panelInner {
  min-height: 0;
  overflow: hidden;
}

@media (prefers-reduced-motion: reduce) {
  .collapsible,
  .trigger,
  .panel {
    transition: none;
  }
}
